import axios from 'axios';

export default {
    pre_insercion(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_compp_atradius.pre_insercion",
				"p_args_in": JSON.stringify({
                    "p_usuario": p_usuario
				  })
			})
	},

	recuperar(p_email, p_usuario){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_atradius.recuperar",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario
				})
		})
	},

	eliminar(p_email, p_usuario, p_poliza){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_atradius.eliminar",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_poliza": p_poliza
				})
		})
	},

	info_poliza(p_email, p_usuario, p_poliza){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_atradius.info_poliza",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_poliza": p_poliza
				})
		})
	},

	agregar(p_email, p_usuario, p_poliza){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_atradius.agregar",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_poliza": p_poliza
				})
		})
	},
}